"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpanHighlight = void 0;

require("@tiptap/extension-text-style");

var _core = require("@tiptap/core");

/**
 * This extension allows you to color your text.
 * @see https://tiptap.dev/api/extensions/color
 */
var SpanHighlight = _core.Extension.create({
  name: 'spanHighlight',
  addOptions: function addOptions() {
    return {
      types: ['textStyle']
    };
  },
  addGlobalAttributes: function addGlobalAttributes() {
    return [{
      types: this.options.types,
      attributes: {
        backgroundColor: {
          default: null,
          parseHTML: function parseHTML(element) {
            var _element$style$backgr;

            return (_element$style$backgr = element.style.backgroundColor) === null || _element$style$backgr === void 0 ? void 0 : _element$style$backgr.replace(/['"]+/g, '');
          },
          renderHTML: function renderHTML(attributes) {
            if (!attributes.backgroundColor) {
              return {};
            }

            return {
              style: "background-color: ".concat(attributes.backgroundColor)
            };
          }
        },
        role: {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute('role');
          },
          renderHTML: function renderHTML(attributes) {
            if (!attributes['role']) {
              return {};
            }

            return {
              role: attributes['role']
            };
          }
        },
        'aria-roledescription': {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute('aria-roledescription');
          },
          renderHTML: function renderHTML(attributes) {
            if (!attributes['aria-roledescription']) {
              return {};
            }

            return {
              'aria-roledescription': attributes['aria-roledescription']
            };
          }
        },
        tabindex: {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute('tabindex');
          },
          renderHTML: function renderHTML(attributes) {
            if (!attributes['tabindex']) {
              return {};
            }

            return {
              tabindex: attributes['tabindex']
            };
          }
        }
      }
    }];
  },
  addCommands: function addCommands() {
    return {
      setSpanHighlight: function setSpanHighlight(backgroundColor) {
        return function (_ref) {
          var chain = _ref.chain;
          return chain().setMark('textStyle', {
            backgroundColor: backgroundColor
          }).run();
        };
      },
      unsetSpanHighlight: function unsetSpanHighlight() {
        return function (_ref2) {
          var chain = _ref2.chain;
          return chain().setMark('textStyle', {
            backgroundColor: null
          }).removeEmptyTextStyle().run();
        };
      }
    };
  }
});

exports.SpanHighlight = SpanHighlight;